import { NavLink } from '@/types';

export const Routes: NavLink[] = [
  {
    label: 'About Samuthrika',
    path: 'about',
    sublinks: [
      { label: 'About Academy', path: 'academy' },
      { label: 'About CEO & Founder', path: 'founder' },
      { label: 'Awards & Accolades', path: 'awards-and-accolades' },
      { label: 'Recognitions', path: 'recognitions' },
      {
        label: 'Special Events',
        path: 'special-events',
        sublinks: [
          { label: 'Lifetime Achievement', path: 'lifetime-achievement' },
          { label: 'FETTACK - Signature Event', path: 'fettack' },
          { label: 'Journey as a Rotary Member', path: 'rotary-journey' },
          { label: 'Event Management', path: 'event-management' },
        ],
      },
    ],
  },
  {
    label: 'Courses',
    path: 'courses',
    sublink_route: 'courses.showCategory',
  },
  {
    label: 'Summer Camp',
    path: 'summer-camp',
  },
  {
    label: 'Online Shoppe',
    path: 'shoppe',
    sublink_route: 'shoppe.showGroup',
  },
  {
    label: 'Services',
    path: 'services',
    sublink_route: 'services.showService',
  },
  { label: 'Contact', path: 'contact' },
  { label: 'Career', path: 'career' },
  { label: 'FAQ', path: 'faqs' },
];
